import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const skillCategories = [
    {
      category: 'Programming Languages',
      skills: ['Python', 'C++', 'C', 'Haskell'],
    },
    {
      category: 'Frameworks & Libraries',
      skills: ['PyTorch', 'Pandas', 'Scikit-learn'],
    },
    {
      category: 'Developer Tools & Cloud Platforms',
      skills: ['Git', 'GitHub', 'Docker', 'Linux', 'VS Code', 'YAML', 'Kubernetes', 'AWS'],
    },
    {
      category: 'Web Technologies',
      skills: ['HTML', 'CSS', 'JavaScript', 'React.js'],
    },
    {
      category: 'Databases',
      skills: ['MySQL', 'MongoDB', 'PostgreSQL'],
    },
    {
      category: 'Soft Skills',
      skills: ['Problem Solving', 'Team Collaboration', 'Communication', 'Leadership'],
    },
    {
      category: 'Technologies',
      skills: ['Blockchain (Basics)'],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 },
    },
  };

  return (
    <div className="about">
      <motion.div
        className="about-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="about-header" variants={itemVariants}>
          <h1 className="page-title">
            About <span className="gradient-text">Me</span>
          </h1>
          <div className="title-underline"></div>
        </motion.div>

        <div className="about-content">
          <motion.div className="about-info" variants={itemVariants}>
            <div className="info-card">
              <h2>Hello! I'm SJ Yuvan Dhurkesh</h2>
              <p>
                AWS Certified enthusiastic and adaptable Computer Science undergraduate with strong analytical, problem-solving, and critical-thinking skills. Passionate about leveraging technology to create real-world impact.
              </p>
              <p>
                Hands-on experience in DevOps and Cloud technologies (Docker, Kubernetes, AWS), with a solid foundation in Python and Linux, plus exposure to system monitoring, networking, and automation.
              </p>
              <p>
                I'm currently in my third year of Computer Science Engineering, actively seeking placement opportunities to apply my skills in real-world projects. My journey in tech has been driven by curiosity and a constant desire to learn. I enjoy tackling complex problems and turning ideas into functional, user-friendly applications.
              </p>
            </div>
          </motion.div>

          <motion.div className="skills-section" variants={itemVariants}>
            <h2 className="section-subtitle">Technical Skills</h2>
            <div className="skills-categories">
              {skillCategories.map((category, index) => (
                <motion.div
                  key={index}
                  className="skill-category"
                  variants={itemVariants}
                >
                  <h3 className="category-title">{category.category}</h3>
                  <div className="skills-tags">
                    {category.skills.map((skill, idx) => (
                      <motion.span
                        key={idx}
                        className="skill-tag"
                        whileHover={{ scale: 1.05 }}
                      >
                        {skill}
                      </motion.span>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.div className="education-section" variants={itemVariants}>
          <h2 className="section-subtitle">Education</h2>
          <div className="education-card">
            <div className="education-icon">🎓</div>
            <div className="education-content">
              <h3>Bachelor of Technology in Computer Science</h3>
              <p className="education-school">Amrita Vishwa Vidyapeetham</p>
              <p className="education-location">Coimbatore, India</p>
              <p className="education-year">2023 - 2027 (Expected)</p>
              <p className="education-desc">
                Currently in third year, maintaining strong academic performance
                while actively participating in coding competitions and technical
                projects.
              </p>
            </div>
          </div>
          
          <div className="education-card">
            <div className="education-icon">🏫</div>
            <div className="education-content">
              <h3>CBSE</h3>
              <p className="education-school">Woodside School</p>
              <p className="education-location">Ooty, India</p>
              <p className="education-desc">
                Completed secondary education with a strong foundation in science and mathematics.
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default About;
